import { render, staticRenderFns } from "./origenPedido.vue?vue&type=template&id=d094a6b4&scoped=true&"
import script from "./origenPedido.vue?vue&type=script&lang=js&"
export * from "./origenPedido.vue?vue&type=script&lang=js&"
import style0 from "./origenPedido.vue?vue&type=style&index=0&id=d094a6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d094a6b4",
  null
  
)

export default component.exports